import React, { useState } from 'react'
import Title from '@components/Title';
import Layout from '@Layout';
import { toast } from 'react-toastify';
import { Autocomplete, Button, Chip, TextField } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import validator from 'validator';
import axios from '@MyAxios';

function InviteFriends() {
  const [tempEmail, setTempEmail] = useState('');
  const [inviteEmails, setInviteEmails] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleAddEmail = (emails, reason, newEmail = tempEmail) => {
    if(emails?.length > 10)
      return toast.error('You cannot invite more than 10 emails at a time');

    if(inviteEmails.includes(newEmail))
      return toast.error('Email already in list');

    if(reason == 'createOption') {
      let trimmedEmail = newEmail.trim();

      if(!trimmedEmail)
        return toast.error('Please enter an email');

      if(!validator.isEmail(trimmedEmail)) {
        setTempEmail(trimmedEmail);
        return toast.error(`Email format "${trimmedEmail}" is invalid`);
      }
  
      setInviteEmails(emails);
      setTempEmail('');
    }
  }

  const handleRemoveEmail = (email) => {
    setInviteEmails(inviteEmails.filter(e => e !== email));
  }

  const handleSubmit = () => {
    if(inviteEmails.length === 0)
      return toast.error('No emails entered to invite');

    setLoading(true);
    axios.get('/invite-friends', {
      params: {
        userEmails: inviteEmails
      }
    })
      .then(res => {
        toast.success(res.data?.message);
        setInviteEmails([]);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Layout>
      <Title back={"/"}>Invite Friends</Title>

      <div className='p-4 mt-4'>
        <Autocomplete
          freeSolo
          multiple
          options={[]}
          clearIcon={false}
          value={inviteEmails}
          inputValue={tempEmail}
          onInputChange={(_, value) => setTempEmail(value)}
          // onInputChange={(e, value, reason) => handleAddEmail(val)}
          onChange={(_, values, reason, details) => handleAddEmail(values, reason, details?.option)}
          props
          renderTags={(value, props) =>
            value.map((option, index) => (
              <Chip
                {...props({ index })}
                label={option}
                onDelete={() => handleRemoveEmail(option)}
              />
            ))
          }
          renderInput={(params) =>
            <TextField
              {...params}
              label="Enter emails to invite"
              // InputProps={{
              //   ...params.InputProps,
              //   endAdornment:
              //     <SendIcon
              //       className='cursor-pointer'
              //     />
              // }}
            />
          }
        />

        <div className='flex justify-end mt-4'>
          {Boolean(tempEmail) ? (
            <Button
              color='primary'
              variant='contained'
              disabled={!validator.isEmail(tempEmail)}
              onClick={() => handleAddEmail([ ...inviteEmails, tempEmail], 'createOption')}
            >
              Add Email
            </Button>
          ) : (
            <Button
              color='primary'
              variant='contained'
              onClick={handleSubmit}
              disabled={loading || inviteEmails.length === 0}
            >
              Invite to Serkohls
            </Button>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default InviteFriends;